import { createSlice } from "@reduxjs/toolkit";
import { currentMonthRange } from "../commom/DateFormat";

/*
    CENTRALIZED DATE RANGE STATE

    RULE:
    - On every refresh/load → Current Month
    - All screens using Redux date range will use Current Month by default
    - No stale localStorage month/custom values
*/

const getDefaultCurrentMonth = () => {
    const { start, end } = currentMonthRange();

    return {
        startDate: start,
        endDate: end
    };
};

const initialMonthRange = getDefaultCurrentMonth();

// Sync localStorage immediately
window.localStorage.setItem("startDate", initialMonthRange.startDate);
window.localStorage.setItem("endDate", initialMonthRange.endDate);
window.localStorage.setItem("dateRange", "Current Month");

export const DateRangeReducer = createSlice({
    name: "DateRangeReducer",

    initialState: {
        startDate: initialMonthRange.startDate,
        endDate: initialMonthRange.endDate
    },

    reducers: {

        /*
            ALWAYS RESET TO CURRENT MONTH
            Use this on:
            - page refresh
            - login
            - dashboard load
        */
        setDateRange: (state) => {

            const { start, end } = currentMonthRange();

            state.startDate = start;
            state.endDate = end;

            window.localStorage.setItem("startDate", start);
            window.localStorage.setItem("endDate", end);
            window.localStorage.setItem("dateRange", "Current Month");
        },

        /*
            Update single date
        */
        updateDate: (state, action) => {
            const { name, value } = action.payload;

            if (name === "endDate") {
                state.endDate = value;
                window.localStorage.setItem("endDate", value);
            } else {
                state.startDate = value;
                window.localStorage.setItem("startDate", value);
            }
        },

        /*
            Update full date range
        */
        updateRangeOfDate: (state, action) => {
            const { startDate, endDate } = action.payload;

            state.startDate = startDate;
            state.endDate = endDate;

            window.localStorage.setItem("startDate", startDate);
            window.localStorage.setItem("endDate", endDate);
        },

        /*
            Explicit helper:
            reset everything to current month
        */
        resetToCurrentMonth: (state) => {

            const { start, end } = currentMonthRange();

            state.startDate = start;
            state.endDate = end;

            window.localStorage.setItem("startDate", start);
            window.localStorage.setItem("endDate", end);
            window.localStorage.setItem("dateRange", "Current Month");
        }
    }
});

export const {
    setDateRange,
    updateDate,
    updateRangeOfDate,
    resetToCurrentMonth
} = DateRangeReducer.actions;

export default DateRangeReducer.reducer;